import React,{memo} from 'react';
import './styles/TableComponent.css';

const TableComponent = ({
  title,
  items,
  itemType,
  columns,
  getCurrentLogic,
  handleLogicChange,
  handlePropertyChange,
  isGridType,
  showAllProperties = true
}) => {
  if (!items || items.length === 0) {
    return <p>No {title.toLowerCase()} available.</p>;
  }

  const defaultColumns = [
    { key: 'index', label: 'Index', width: '5%' },
    { key: 'label', label: 'Label', width: '25%' },
    { key: 'filterLogic', label: 'Filter Logic', width: '30%' }
  ];

  if (showAllProperties) {
    defaultColumns.push(
      { key: 'other', label: 'Other', width: '10%', type: 'checkbox' },
      { key: 'screenout', label: 'Screen', width: '10%', type: 'checkbox' },
      { key: 'exclusive', label: 'Exclusive', width: '10%', type: 'checkbox' },
      { key: 'fix', label: 'Fix/EV.', width: '10%', type: 'checkbox' }
    );
  }

  const tableColumns = columns || defaultColumns;

  const getLabel = (item) => {
    return item.text || item.title || item.label || '';
  };

  const handleLogicInputChange = (index, value) => {
    console.log('TableComponent handleLogicInputChange:', { index, value, itemType });
    if (handleLogicChange) {
      handleLogicChange(index, value);
    }
  };

  const handleCheckboxChange = (index, property, checked) => {
    console.log('TableComponent handleCheckboxChange:', { index, property, checked, itemType });
    if (handlePropertyChange) {
      handlePropertyChange(property, itemType, index, checked);
    }
  };

  return (
    <div className={`${itemType.toLowerCase()}-section table-container`}>
      <h5 className="table-title">{title} (with Logic)</h5>
      <div className="table-wrapper">
        <table className={`${itemType.toLowerCase()}-table values-table`}>
          <colgroup>
            {tableColumns.map((col, idx) => (
              <col key={idx} style={{ width: col.width }} />
            ))}
          </colgroup>
          <thead>
            <tr>
              {tableColumns.map((col, idx) => (
                <th key={idx} className="table-header">
                  <div className="header-content">
                    {col.label}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
  
            {items.map((item, index) => {
              const currentLogic = getCurrentLogic 
                ? getCurrentLogic(itemType, index) 
                : item.filterLogic || '';

              console.log(`TableComponent row ${index}:`, { currentLogic, item });

              return (
                <tr key={index} className="table-row">
                  {tableColumns.map((col, colIdx) => {
                    // If custom render function exists, use it
                    if (col.render) {
                      return <td key={colIdx} className="table-cell">{col.render(item, index)}</td>;
                    }
                    
                    if (col.key === 'index') {
                      return (
                        <td key={colIdx} className="table-cell index-cell">
                         {item.index ?? index}
                        </td>
                      );
                    }
                    
                    if (col.key === 'label') {
                      return (
                        <td key={colIdx} className="table-cell label-cell">
                          {getLabel(item)}
                        </td>
                      );
                    }
                    
                    if (col.key === 'filterLogic') {
                      return (
                        <td key={colIdx} className="table-cell logic-cell">
                          <input
                            type="text"
                            value={currentLogic}
                            onChange={(e) => handleLogicInputChange(index, e.target.value)}
                            placeholder={`e.g. Filter logic for ${itemType}`}
                            className="logic-input"
                          />
                        </td>
                      );
                    }
                    
                    if (col.type === 'checkbox') {
                      return (
                        <td key={colIdx} className="table-cell checkbox-cell">
                          <div className="checkbox-container">
                            <input
                              type="checkbox"
                              checked={item[col.key] || false}
                              onChange={(e) => handleCheckboxChange(index, col.key, e.target.checked)}
                              className="property-checkbox"
                            />
                          </div>
                        </td>
                      );
                    }
                    
                    // Default text display
                    return (
                      <td key={colIdx} className="table-cell">
                        {item[col.key] || ''}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      
    </div>
  );
};

export default memo(TableComponent);